import React, { FC } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ImgWebp } from '../../commons/ImgWeb';
import tvWebp from '../../../assets/images/cartoons/Serials.webp';
import tvPng from '../../../assets/images/cartoons/Serials.png';
import RollWebp from '../../../assets/images/cartoons/Roll.webp';
import RollPng from '../../../assets/images/cartoons/Roll.png';
import ClapWebp from '../../../assets/images/cartoons/Clap2.webp';
import ClapPng from '../../../assets/images/cartoons/Clap2.png';
import { FormInputText } from '../../inputs/FormInputText';
import { ButtonClassNames, InputTextFormat, InputRegexPattern } from '../../../models/Common';
import { CustomMUIButton } from '../../commons/buttons/CustomMUIButton';
import PopcornWebp from '../../../assets/images/cartoons/Popcorn.webp';
import PopcornPng from '../../../assets/images/cartoons/Popcorn.png';

interface ForCtvProps {
  handleCallMeBack: ({ phone }: { phone: string }) => void;
  isLoadingCallMeBack: boolean;
}

export const ForCtv: FC<ForCtvProps> = ({ handleCallMeBack, isLoadingCallMeBack }) => {
  const { t } = useTranslation();
  const methods = useForm();
  const { handleSubmit } = methods;

  return (
    <>
      <div className="header for-ctv for-ctv__header">
        <ImgWebp webpSrc={tvWebp} fallback={tvPng} alt="tv" className="for-ctv__header__tv" />
        <ImgWebp webpSrc={RollWebp} fallback={RollPng} alt="roll" className="for-ctv__header__roll" />
        <ImgWebp webpSrc={ClapWebp} fallback={ClapPng} alt="clap" className="for-ctv__header__clap" />
      </div>
      <div className="content">
        <h1 className="title">{t('connectionBrizTv.watchMoviesInBrizTvOnlineCinema')}</h1>
        <div className="content__form-info-container">
          <div className="content__form-info-container__form-container">
            <FormProvider {...methods}>
              <form
                className="content__form-info-container__form-container__form"
                onSubmit={handleSubmit(handleCallMeBack)}
              >
                <article className="content__form-info-container__title">
                  {t('connectionBrizTv.connectingToBrizTv')}
                </article>
                <FormInputText
                  name="phone"
                  label={t('input.phone')}
                  className="primary"
                  isRequired
                  format={InputTextFormat.Phone}
                  pattern={InputRegexPattern.Phone}
                  minLength={9}
                />
                <div>
                  <CustomMUIButton
                    label={t('common.sendRequest')}
                    type="submit"
                    className={ButtonClassNames.PrimaryFulfilled}
                    isBold
                    isLoading={isLoadingCallMeBack}
                  />
                </div>
              </form>
            </FormProvider>
            <ImgWebp
              webpSrc={PopcornWebp}
              fallback={PopcornPng}
              alt="popcorn"
              className="content__form-info-container__form-container__popcorn"
            />
          </div>
          <div className="content__form-info-container__info">
            <article className="content__form-info-container__title">
              {t('connectionBrizTv.connectionInformation')}
            </article>
            <p>{t('connectionBrizTv.toWatchBrizTvYouNeedInternet')}</p>
            <p>{t('connectionBrizTv.watchingBrizTvIsAvailableOnSmartTvEnabledComputerTabletSmartphone')}</p>
            <p>{t('connectionBrizTv.brizTvIsModernAlternativeToCableTv')}</p>
          </div>
        </div>
      </div>
    </>
  );
};
